import { User } from '../../lib/user'
import { Settings } from '../../lib/settings'
import { Game, GameStatus, Actions } from './Game'
import { GAME_MODE_CUSTOM } from '../../constants/strings'
import { DAILY_LIST, getSolutionFromCustomId } from '../../lib/words'
import { GameStats } from '../../lib/localStorage'
import { useMemo, forwardRef } from 'react'

type Props = {
  puzzleId: string,
  seed: string
  user: User
  settings: Settings,
  actions: Actions,
  setIsStatsModalOpen: (isOpen: boolean) => void
  onGameStatusChange: (status: GameStatus) => void
  onUpdateStats: (stats: GameStats) => void
  onHint: () => void
  setResponsive: (isResponsive: boolean) => void
}

export const CustomGame = forwardRef(({
  puzzleId,
  seed,
  user,
  settings,
  actions,
  setIsStatsModalOpen,
  onGameStatusChange,
  onUpdateStats,
  onHint,
  setResponsive
}: Props, ref) => {

  const solution = useMemo(() => getSolutionFromCustomId(puzzleId, seed), [puzzleId, seed]);

  if (!solution) {
    throw new Error('puzzle not found')
  }
  const header = <div className="flex flex-col items-center justify-center">
    <div className="flex justify-center text-gray-500 dark:text-gray-300 p-1">
      <h2 className="title text-lg">{solution.data?.title || 'Custom'}</h2>
      {solution.data?.creator && 
        <h2 className="ml-1 text-sm dark:text-gray-300 flex items-center justify-center title">
          - By {solution.data?.creator}
        </h2>
      }
    </div>
    {solution.data?.hint &&
      <div className="text-sm dark:text-gray-300">
        Hint: {solution.data?.hint}
      </div>
    }
  </div>

  return <Game
    key={puzzleId}
    ref={ref}
    captureStats={false}
    header={header}
    isArchive={false}
    list={DAILY_LIST}
    user={user}
    solution={solution}
    mode={GAME_MODE_CUSTOM}
    settings={settings}
    actions={actions}
    setIsStatsModalOpen={setIsStatsModalOpen}
    onGameStatusChange={onGameStatusChange}
    onUpdateStats={onUpdateStats}
    onHint={onHint}
    setResponsive={setResponsive}
  />
})

